import { ComponentProps, useCallback } from 'react';
import { DatePicker, getDatePickerMode, getPeriod } from '..';
import { DATE_FORMAT } from '../../utils';
import { Dayjs } from 'dayjs';
import { Frequency } from '../../../dataobject';
import { DatePickerProps } from 'antd';

export interface PeriodRangePickerProps
  extends Omit<
    ComponentProps<typeof DatePicker.RangePicker>,
    'format' | 'onChange' | 'value' | 'picker'
  > {
  value?: [Dayjs | null, Dayjs | null];
  onChange: (value: [Dayjs | null, Dayjs | null]) => void;
  frequency?: Frequency;
}

export const PeriodEndRangePicker = (props: PeriodRangePickerProps) => {
  const { value, onChange, frequency, ...rest } = props;
  const format: DatePickerProps['format'] = useCallback(
    (value: Dayjs) => getPeriod(value, frequency)[1]?.format(DATE_FORMAT) || '',
    [frequency],
  );
  const handleChange = useCallback(
    (dates: [Dayjs | null, Dayjs | null] | null) => {
      if (dates === null) {
        onChange([null, null]);
        return;
      }

      const [from, to] = dates || [];
      const adjustedValue = [
        getPeriod(from, frequency)[1],
        getPeriod(to, frequency)[1],
      ] as [Dayjs | null, Dayjs | null];

      onChange(adjustedValue);
    },
    [frequency, onChange],
  );

  return (
    <DatePicker.RangePicker
      {...rest}
      picker={getDatePickerMode(frequency)}
      format={format}
      value={value}
      onChange={handleChange}
    />
  );
};
